import { motion } from "framer-motion";

/**
 * Official WhatsApp brand mark (green tile + white phone glyph).
 * Subtle pulse aura preserved, brand colors untouched.
 */
export default function WhatsAppMark({ size = 56 }) {
  return (
    <div
      className="relative inline-flex items-center justify-center"
      style={{ width: size, height: size }}
      aria-hidden="true"
    >
      {/* Soft pulsing aura — kept neutral green to match brand */}
      <motion.span
        className="absolute inset-0 rounded-2xl bg-[#25D366]/35 blur-xl"
        animate={{ opacity: [0.35, 0.7, 0.35], scale: [0.9, 1.05, 0.9] }}
        transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.span
        className="absolute inset-[-6px] rounded-2xl border border-white/15"
        animate={{ opacity: [0.3, 0.9, 0.3] }}
        transition={{ duration: 2.6, repeat: Infinity, ease: "easeInOut" }}
      />
      <motion.span
        className="relative w-full h-full rounded-2xl bg-[#25D366] shadow-[0_18px_36px_-12px_rgba(37,211,102,0.85)] flex items-center justify-center"
        animate={{ y: [0, -2, 0] }}
        transition={{ duration: 3, repeat: Infinity, ease: "easeInOut" }}
      >
        <svg
          viewBox="0 0 32 32"
          width={size * 0.6}
          height={size * 0.6}
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3C8.82 3 3 8.82 3 16c0 2.29.6 4.43 1.65 6.3L3 29l6.9-1.62A12.93 12.93 0 0 0 16 29c7.18 0 13-5.82 13-13S23.18 3 16 3Zm7.5 18.46c-.32.9-1.84 1.7-2.55 1.78-.66.08-1.46.12-2.36-.15-.54-.18-1.24-.41-2.13-.79-3.75-1.62-6.2-5.4-6.39-5.65-.18-.25-1.51-2.01-1.51-3.84 0-1.83.96-2.73 1.3-3.1.34-.37.74-.46 1-.46.25 0 .5 0 .72.01.23.01.54-.09.84.64.32.78 1.07 2.69 1.16 2.88.09.19.15.41.03.66-.12.25-.18.41-.36.63-.18.22-.38.5-.54.67-.18.18-.37.38-.16.74.21.37.93 1.54 2 2.5 1.37 1.23 2.53 1.61 2.9 1.79.37.18.59.15.81-.09.22-.25.93-1.09 1.18-1.46.25-.37.5-.31.84-.18.34.12 2.16 1.02 2.53 1.21.37.18.62.28.71.43.09.16.09.91-.23 1.81Z"
            fill="#FFFFFF"
          />
        </svg>
      </motion.span>
    </div>
  );
}
